import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom"
import './rsbutton.css'
const RsLink = ({to,onClick, className, children, iconClass}) => {
  return (
    <Link
      to={to}
      className={`btn ${className}`}
      onClick={onClick}
    >
     <i className={`font-size-16 align-middle btn-i ${iconClass}`}></i> {children}
    </Link>
  );
};

RsLink.propTypes = {
to:PropTypes.string,
className: PropTypes.string,
onClick: PropTypes.func,
children: PropTypes.string,
iconClass:PropTypes.string
};
RsLink.defaultProps = {
    to:'#',
    className: 'btn-cancle',
    iconClass:'bx bx-window-close',
    onClick: () => {},
  };
export default RsLink;
